import { RecapEmpty } from './RecapPanel';

const BYTES_PER_MB = 1024 * 1024;

interface AttachmentRecapProps {
    name: string | null;
    sizeBytes: number | null;
}

/** The manufacturer PDF merged into the clinical PDF: its name and size, or that none is attached. */
export function AttachmentRecap({ name, sizeBytes }: AttachmentRecapProps) {
    if (name === null) return <RecapEmpty>Not attached</RecapEmpty>;
    return (
        <>
            <div className="text-sm text-gray-800 truncate">{name}</div>
            {sizeBytes !== null && (
                <div className="text-xs text-gray-500 mt-0.5">
                    {(sizeBytes / BYTES_PER_MB).toFixed(2)} MB
                </div>
            )}
        </>
    );
}
